<template>
  <div class="insider-section" :id="product.slug">
    <h2 class="insider-section-h2">{{ product.title }}</h2>
    <div ref="scrollBox" class="scroll-box-container">
      <div class="scroll-box-inner">
        <div v-for="card in product.cards.data.slice(0, limit)">
          <div v-if="product.slug === 'business-series-webinars'">
            <ProductDisplayCardComponent
              :productId="card.id"
              :productTitle="product.title"
              :slug="product.slug"
              :subTitle="card.name"
              :date="
                format_date_month_year(
                  what_date_to_use(card.publish_date, card.webinar_date)
                )
              "
              :buttonUrl="card.url"
              :vimeoId="card.webinars[0].vimeo_id"
              :isNew="
                is_new(what_date_to_use(card.publish_date, card.webinar_date))
              "
              :playBtn="true"
              :pptAttachment="card.webinars[0].ppt_attachment"
              :pptSize="card.webinars[0].ppt_file_size"
              :pptName="card.webinars[0].ppt_file_name"
            />
          </div>
          <div v-if="product.slug === 'latest-economic-articles'">
            <ProductDisplayCardComponent
              :slug="product.slug"
              :title="card.report_type.name"
              :date="format_published_on_date(card.published_date)"
              :otherDate="format_published_on_date(card.issue)"
              :buttonUrl="card.report_type.url"
              :popOut="true"
              :hasImage="true"
              :imagePath="card.report_type.image"
            />
          </div>
          <div v-if="product.slug === 'executive-series-keynotes'">
            <ProductDisplayCardComponent
              :productTitle="product.title"
              :slug="product.slug"
              :subTitle="card.name"
              :date="
                format_date_month_year(
                  what_date_to_use(card.publish_date, card.webinar_date)
                )
              "
              :buttonUrl="card.url"
              :vimeoId="card.webinars[0].vimeo_id"
              :isNew="
                is_new(what_date_to_use(card.publish_date, card.webinar_date))
              "
              :playBtn="true"
              :purchased="card.isPaid"
              :pptAttachment="card.webinars[0].ppt_attachment"
              :pptSize="card.webinars[0].ppt_file_size"
              :pptName="card.webinars[0].ppt_file_name"
            />
          </div>
          <div v-if="product.slug === 'trends-talks'">
            <ProductDisplayCardComponent
              :productTitle="product.title"
              :slug="product.slug"
              :date="format_published_on_date(card.publish_date)"
              :subTitle="card.name"
              :youtubeCode="card.youtube_embed_code"
              :isNew="card.is_new"
            />
          </div>
          <div v-if="product.slug === 'recent-announcements'">
            <ProductDisplayCardComponent
              :slug="product.slug"
              :title="card.name"
              :date="format_date_month_day_year(card.date)"
              :description="card.content"
              :buttonUrl="card.slug"
              :readMore="true"
            />
          </div>
          <div v-if="product.slug === 'itr-academy'">
            <ProductDisplayCardComponent
              :slug="product.slug"
              :subTitle="card.name"
              :buttonName="card.button_name"
              :buttonUrl="card.button_url"
              :hasButton="true"
              :hasImage="true"
              :imagePath="card.image"
            />
          </div>
        </div>
        <button
          v-if="product.cards.data.length > limit"
          v-on:click="show_more(product.slug)"
        >
          Show More
        </button>
      </div>
    </div>
    <!-- SCROLL POSITION: {{ scrollPosition }} -->
  </div>
</template>

<script>
  import ProductDisplayCardComponent from '../../components/insider/ProductDisplayCardComponent.vue';
  import moment from 'moment';

  export default {
    name: 'ProductDisplayComponent',
    components: { ProductDisplayCardComponent },
    props: {
      product: {
        value: [Object, Array],
        // required: true,
      },
    },
    data: () => ({
      scrollPosition: 0,
      ismobiledevice: false,
      jsonReady: true,
      hasVideo: true,
      limit: 7,
    }),
    methods: {
      show_more(slug) {
        this.limit += 7;
      },
      what_date_to_use(publishDate, webinarDate) {
        if (publishDate) {
          return publishDate;
        } else {
          return webinarDate;
        }
      },
      format_date_month_year(value) {
        if (value) {
          return moment(String(value)).format('MMMM YYYY');
        }
      },
      format_date_month_day_year(value) {
        if (value) {
          return moment(String(value)).format('MMMM DD, YYYY');
        }
      },
      format_published_on_date(value) {
        if (value) {
          return (
            'Published on ' + moment(String(value)).format('MMMM DD, YYYY')
          );
        }
      },
      is_new(value) {
        var week = moment(String(value)).isSame(moment().toDate(), 'week');

        if (week === true) {
          return 'true';
        } else {
          return 'false';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .insider-section {
    margin-top: 50px;
    .insider-section-h2 {
      margin-bottom: 20px;
    }
  }
  .scroll-box-container {
    scrollbar-width: thin;
    // scrollbar-color: #4d7fff #ddd;
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    height: 410px;

    .scroll-box-inner {
      max-height: 400px;
      padding-bottom: 2em;
      margin-right: 2em;
      display: flex;
      gap: 70px;
      width: 90%;
      // width: calc(33.3333333333% - 50px);

      // overflow-y: hidden;
    }

    &::-webkit-scrollbar {
      width: 10px;
      height: 15px;
    }

    &::-webkit-scrollbar-thumb {
      background: #a7a9ab; //linear-gradient(to bottom right, lightgray 0%, lightgray 100%);
      border-radius: 5px;

      // &:horizontal {
      //     height: 10px;
      // }
    }

    &::-webkit-scrollbar-thumb:horizontal {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border: 1px solid #dbdcde;
      border-radius: 5px;
    }

    &::-webkit-scrollbar-button {
      display: none;
      // background-color: #4d7fff;
      // border-radius: 5px;
    }
  }

  .scroll-box {
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar-button {
      display: none !important;
    }
    &::-webkit-scrollbar-track {
      background: orange !important;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      width: 80px;
      border-radius: 10px;
    }

    // .scroll-box-inner {
    //     max-height: 400px;
    //     padding-bottom: 2em;
    //     margin-right: 2em;
    //     display: flex;
    //     width: 60%;
    // }
  }

  .embed-container {
    max-height: 500px;
    padding-bottom: 1em;
  }
</style>
